import i18n from 'i18next';

const TRANSLATION_PREFIX = 'modules.licenses.license-forms.license-inputs';

export const getDurationInMonths = () => [
  {
    id: 1,
    name: i18n.t(`${TRANSLATION_PREFIX}.license-duration-options.1-month`),
  },
  {
    id: 3,
    name: i18n.t(`${TRANSLATION_PREFIX}.license-duration-options.3-months`),
  },
  {
    id: 6,
    name: i18n.t(`${TRANSLATION_PREFIX}.license-duration-options.6-months`),
  },
];

export const getDurationInMonthsName = (duration) => {
  return getDurationInMonths(duration)?.name;
};
